const URL = '/reportes_ventas';

const state = {
  edited: {
    debitos_totales: null,
    debitos_precio_pleno: null,
    debitos_precio_subsidio: null,
    bonos_cancelados: null,
    creditos_precio_usuario: null,
    creditos_precio_pleno: null,
    deuda_usuario_total: null,
  },
  filters: {
    fecha_from: null,
    fecha_to: null,
  },
  loading: false,
}

// GETTERS
const getters = {
  edited(state) {
    return state.edited
  },
  filters(state) {
    return state.filters
  },
  loading(state) {
    return state.loading
  },
}

// ACTIONS
const actions = {
  onClearEdited({ commit }) {
    commit('setEdited', {
      debitos_totales: null,
      debitos_precio_pleno: null,
      debitos_precio_subsidio: null,
      bonos_cancelados: null,
      creditos_precio_usuario: null,
      creditos_precio_pleno: null,
      deuda_usuario_total: null,
    })
  },
  onClearFilters({ commit }) {
    commit('setFilters', {
      fecha_from: null,
      fecha_to: null,
    })
  },
  onFetch({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL, {
        params: {
          fecha_from: state.filters.fecha_from,
          fecha_to: state.filters.fecha_to,
        }
      })
        .then(response => {
          commit('setEdited', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  }
}

// MUTATIONS
const mutations = {
  setEdited(state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setFilters(state, payload) {
    state.filters = Object.assign({}, payload)
  },
  setLoading(state, payload) {
    state.loading = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
